export default __webpack_public_path__ + "static/media/plate.bdb43b4b.png";